<style type="text/css" scoped>
@keyframes progress {
  0% { --percentage: 0; }
  100% { --percentage: var(--value); }
}

@property --percentage {
  syntax: '<number>';
  inherits: true;
  initial-value: 0;
}

[role="progressbar"] {
  --percentage: var(--value);
  --primary: var(--primary);
  --secondary: var(--secondary);
  --size: 20px;
  animation: progress 2s 0.5s forwards;
  width: var(--size);
  aspect-ratio: 2 / 1;
  border-radius: 50% / 100% 100% 0 0;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

[role="progressbar"]::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: conic-gradient(from 0.75turn at 50% 100%, var(--primary) calc(var(--percentage) * 1% / 2), var(--secondary) calc(var(--percentage) * 1% / 2 + 0.1%));
  mask: radial-gradient(at 50% 100%, white 55%, transparent 55.5%);
  mask-mode: alpha;
  -webkit-mask: radial-gradient(at 50% 100%, #0000 55%, #000 55.5%);
  -webkit-mask-mode: alpha;
}
</style>

<h1 class="u-sr-only" xmlns="http://www.w3.org/1999/html">{{ 'Profile.Menu.Dashboard' | translate }}</h1>
<section class="c-section c-section--first c-section--open c-section--static u-no-pb" panel>
  <loader-overlay *ngIf="vm.loading"></loader-overlay>
  <div class="c-section__header u-hidden@md-and-up">
    <h1 class="c-section__title c-section__title--sm">{{ 'Hr_Dashboard.Usage_Dashboard' | translate }}</h1>
  </div>
  <div class="c-section__content">
    <div class="o-grid">
      <div class="o-grid__cell c-cell">
        <div class="c-content u-no-ph">
          <div class="o-grid o-grid--wrap">
            <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--left u-no-p">
              <section class="c-section--open c-section--static c-section--fit@md-and-up u-no-pb" style="margin-left: 15px" panel>
                <div class="o-grid o-grid--fit">
                  <div class="c-cell">
                    <div *ngIf="vm.generatedPreview?.invitationDate"
                         class="c-text c-text--bold c-text--main u-no-m" style="font-size: 16px">
                      {{ 'Hr_Dashboard.Joined_Data' | translate }} {{vm.generatedPreview.invitationDate}}
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--right u-no-p">
              <form class="c-form">
                <div class="o-grid">
                  <div class="o-grid__cell o-grid__cell--slim">
                    <div *ngIf="vm.dateRangeModel" class="c-form__group c-form__group--icon u-osb-sm">
                      <i class="o-icon o-icon--schedule c-form__icon" aria-hidden="true"></i>
                      <input-datepicker-new id="{{ 'reportDateRange-1'  }}"
                                            name="terminationDate"
                                            [(model)]="vm.dateRangeModel"
                                            [hasTimepicker]="false"
                                            [hasCalendarIcon]="false"
                                            [minDate]="vm.dateRangeMin"
                                            [isSmall]="true"
                                            [isSingleDate]="false"
                                            [isRequired]="false"></input-datepicker-new>
                    </div>
                  </div>
                  <div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-fixed u-no-p"
                       style="margin-right: 5px">
                    <a id="statisticsDownloadLink" 
                       href="javascript:void(0)"
                       class="c-button c-button--s1 c-button--fit"
                       (click)="vm.generateReport()"><i
                        class="o-icon o-icon--download o-icon--chat"
                        aria-hidden="true"></i> {{ 'Hr_Dashboard.Export' | translate
                      }}
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div *ngIf="!vm.loading">
  <div class="o-grid o-grid--wrap">
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p">
      <section class="c-section--open c-section--static c-section--fit@md-and-up u-no-pb" style="margin-left: 15px" panel>
        <div class="o-grid o-grid--fit">
          <div class="o-grid__cell c-cell">
            <div class="c-text c-text--bold c-text--main u-no-m" style="font-size: 20px">
              1. {{ 'Hr_Dashboard.Usage_And_Insights' | translate }} {{vm.isMinuDoc ? ('Hr_Dashboard.Usage_And_Insights_Addition' | translate) : ''}}
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <div class="o-grid o-grid--wrap">
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p">
      <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
        <div class="c-section__content">
          <div class="o-grid o-grid--fit">
            <div class="o-grid__cell c-cell">
              <div class="c-card c-card--height-fit">
                <div class="c-content u-no-pv u-ost-md u-osb-md">
                  <span class="c-text c-text--bold c-text--main u-no-m">{{ 'Hr_Dashboard.Utilization_In_Period' | translate }}</span>
                  <table-utilization-in-period [generatedPreview]="vm.generatedPreview"></table-utilization-in-period>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p">
      <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
        <div class="c-section__content">
          <div class="o-grid o-grid--fit">
            <div class="o-grid__cell c-cell">
              <div class="c-card c-card--height-fit">
                  <div class="c-content u-no-pv u-ost-md u-osb-md">
                    <span class="c-text c-text--bold c-text--main u-no-m">{{ 'Hr_Dashboard.Services_Used' | translate }}</span>
                    <table-services-used [generatedPreview]="vm.generatedPreview"></table-services-used>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <div class="o-grid o-grid--wrap">
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p">
      <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
        <div class="c-section__content">
          <div class="o-grid o-grid--fit">
            <div class="o-grid__cell c-cell">
              <div class="c-card c-card--height-fit">
                <div class="c-content u-no-pv u-ost-md u-osb-md">
                                                <span class="c-text c-text--bold c-text--main u-no-m">
                                                {{ 'Hr_Dashboard.Sessions_In_Period' | translate }}</span>
                  <hr-comparison-period-info-popover *ngIf="!vm.isSmallSizeWindow"
                                                     placement="right"
                                                     [data]="vm.getTranslationTextForPopover()"
                                                     (click)="$event.preventDefault()"
                                                     style="vertical-align:middle" class="u-osl-xs">
                  </hr-comparison-period-info-popover>
                  <table-usage-statistics [generatedPreview]="vm.generatedPreview"></table-usage-statistics>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p">
      <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
        <div class="c-section__content">
          <div class="o-grid o-grid--fit">
            <div class="o-grid__cell c-cell">
              <div class="c-card c-card--height-fit">
                <div class="c-content u-no-pv u-ost-md u-osb-md">
                                        <span class="c-text c-text--bold c-text--main u-no-m">
                                                {{ 'Hr_Dashboard.Invitations' | translate }}</span>
                  <table-hr-invitations [generatedPreview]="vm.generatedPreview"></table-hr-invitations>
                  <div class="c-text" style="font-size: 13px">
                    <div [hidden]="vm.generatedPreview?.activeUserPercentage > 30">
                      {{vm.disclaimer}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <div class="o-grid o-grid--wrap">
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p">
      <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
        <div class="c-section__content">
          <div class="o-grid o-grid--fit">
            <div class="o-grid__cell c-cell">
              <div class="c-card c-card--height-fit">
                <div class="c-content u-no-pv u-ost-md u-osb-md">
                  <div class="o-grid o-grid--wrap">
                    <div class="o-grid__cell o-grid__cell--w-100 u-no-p">
                                                <span class="c-text c-text--bold c-text--main u-no-m">
                                                {{ 'Hr_Dashboard.Employees_Using_The_Service' | translate }}</span>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-100 u-no-p">
                      <div class="o-grid o-grid--wrap" style="margin-top: 5px; font-size: 14px;">
                        <div class="o-grid__cell o-grid__cell--w-50@up-to-md  o-grid__cell--w-55 o-grid__cell--left u-no-p" style="margin-top: 5px">
                          <div class="c-text">
                            {{ 'Hr_Dashboard.Range_Of_Normal_Usage' | translate }} {{vm.generatedPreview ? vm.generatedPreview.normalUsagePercentageStart || 0 : 0}}-{{vm.generatedPreview ? vm.generatedPreview.normalUsagePercentageEnd || 0 : 0}}%.
                          </div>
                          <div [style]="vm.getUsageIntensityTextStyle()">
                            {{vm.userIntensity}}
                          </div>
                        </div>
                        <div class="o-grid__cell o-grid__cell--w-30@md-and-up o-grid__cell--w-33 o-grid__cell--right u-no-p">
                          <div class="o-grid__cell o-grid__cell--center-h">
                            <div role="progressbar" aria-valuenow="{{vm.generatedPreview?.usagePercentage}}"
                                 aria-valuemin="0" aria-valuemax="100" [style]="vm.getEmployeeProgressBarStyle()">
                              <span class="c-text--bold c-text--main" style="font-size: 25px">{{vm.generatedPreview ? vm.generatedPreview.usagePercentage || 0 : 0}}%</span>
                            </div>
                          </div>
                          <span class="c-text c-text--center" style="font-size: 9px;">{{ 'Hr_Dashboard.Intensity' | translate }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p">
      <div class="o-grid o-grid--wrap o-grid--fit">
        <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p">
          <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb"
                   panel>
            <div class="c-section__content">
              <div class="o-grid o-grid--fit">
                <div class="o-grid__cell c-cell">
                  <div class="c-card c-card--height-fit" style="display: flex; justify-content: center; align-items: center">
                    <div class="c-content u-no-pv u-ost-md u-osb-md">
                      <div class="c-text c-text--bold c-text--main c-text--center u-no-m">
                        {{ 'Hr_Dashboard.Average_Session' | translate }}
                      </div>
                      <div class="c-text c-text--center">
                        <div class="c-text--bold c-text--main u-no-m"
                             style="font-size: 22px; ">{{vm.generatedPreview ? vm.generatedPreview.averageSessionsPerEmployeeCount || 0 : 0}}
                        </div>
                        {{ 'Hr_Dashboard.Per_Employee' | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p">
          <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb"
                   panel>
            <div class="c-section__content">
              <div class="o-grid o-grid--fit">
                <div class="o-grid__cell c-cell">
                  <div class="c-card c-card--height-fit" style="display: flex; justify-content: center; align-items: center">
                    <div class="c-content u-no-pv u-ost-md u-osb-md">
                      <div class="c-text c-text--bold c-text--main c-text--center u-no-m">
                        {{ 'Hr_Dashboard.Average_Rating' | translate }}</div>
                      <div class="c-text--bold c-text--main c-text--center u-no-m">
                                        <span style="font-size: 22px;">
                                            {{vm.generatedPreview ? vm.generatedPreview.netPromoterScore || 0 : 0}}  </span>
                        <span style="font-size: 22px;"> {{'Hr_Dashboard.Out_Of_Max_Rating' | translate}} 5
                                        </span>
                      </div>
                      <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p" style="text-align: center">
                        <item-rating [model]="vm.generatedPreview?.netPromoterScore" [maxRating]="5" [size]="'sm'"></item-rating>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p">
          <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb"
                   panel>
            <div class="c-section__content">
              <div class="o-grid o-grid--fit">
                <div class="o-grid__cell c-cell">
                  <div class="c-card c-card--height-fit" style="display: flex; justify-content: center; align-items: center">
                    <div class="c-content u-no-pv u-ost-md u-osb-md">
                      <div class="c-text c-text--bold c-text--main c-text--center u-no-m">
                        {{ 'Hr_Dashboard.Got_Help' | translate }}</div>
                      <div class="c-text c-text--center">
                        <div class="c-text--bold u-no-m"
                             [style]="vm.getGotHelpedPercentageStyle()">{{vm.generatedPreview?.totalBookingsHelpedInPeriod ? vm.totalBookingsHelpedInPeriodPercentage : 'n/a'}}
                          {{vm.generatedPreview?.totalBookingsHelpedInPeriod ? '%' : ''}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>

  <div class="o-grid o-grid--wrap">
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p">
      <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
        <div class="c-section__content">
          <div class="o-grid">
            <div class="o-grid__cell c-cell">
              <div class="c-card c-card--height-fit" style="min-height: 200px;">
                <div class="c-content u-no-pv u-ost-md u-osb-md">
                  <div class="o-grid" style="margin-left: -15px; ">
                    <div class="o-grid__cell o-grid__cell--w-fit">
                      <span class="c-text c-text--bold c-text--main">
                        {{ 'Hr_Dashboard.Common_Keywords' | translate }}
                      </span>
                        <hr-comparison-period-info-popover *ngIf="!vm.isSmallSizeWindow"
                                                           placement="right"
                                                           [data]="vm.getTranslationTextForPopover()"
                                                           (click)="$event.preventDefault()"
                                                           style="vertical-align:middle" class="u-osl-xs">

                        </hr-comparison-period-info-popover>
                      <select style="width: 60px; margin-left: 16px;"
                              id="groupAdditionalInfoSelect"
                              name="groupAdditionalInfoSelect"
                              [(ngModel)]="vm.selectedGroup"
                              (change)="vm.selectGroup(vm.selectedGroup)">
                        <option *ngFor="let group of vm.groups" [value]="group">{{ group === null ? ('Hr_Dashboard.All' | translate) : (group === 0 ? ('Hr_Dashboard.Empty' | translate) : group) }} </option>
                      </select>
                      <select style="width: 60px; margin-left: 16px;"
                              id="additionalInfoSelect"
                              name="additionalInfoSelect"
                              [(ngModel)]="vm.selectedGroupItem"
                              (change)="vm.selectKeyword(vm.selectedGroupItem)"
                              *ngIf="vm.selectedGroup !== null && vm.selectedGroup !== '0'">
                        <option *ngFor="let groupItem of vm.groupItems" [value]="groupItem">
                            {{ groupItem === null ? ('Hr_Dashboard.All' | translate) : (groupItem === 'empty' ? ('Hr_Dashboard.Empty' | translate) : groupItem) }}
                        </option>
                      </select>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
                      <a class="c-text c-text--right" style="cursor:pointer;" (click)="vm.openFullGraph()" *ngIf="vm.conditionForBarChart && !vm.isFullGraphOpened">
                        {{ 'Hr_Dashboard.View_More' | translate }}</a>
                      <a class="c-text c-text--right" style="cursor:pointer;" (click)="vm.openSlicedGraph()" *ngIf="vm.conditionForBarChart && vm.isFullGraphOpened">
                        {{ 'Hr_Dashboard.View_Less' | translate }}</a>
                    </div>
                  </div>
                  <ng-google-charts *ngIf="vm.conditionForBarChart"
                                    [data]="vm.barChartOptions"
                                    [pngBase64Callback]="vm.getMostCommonKeywordsGraph"></ng-google-charts>
                </div>
                <div *ngIf="!vm.conditionForBarChart" style="text-align: center; margin-top: 10px">
                  <i class="o-icon o-icon--personal" style="font-size:22px;"></i>
                  <div class="c-text c-text--center u-no-m">
                    {{ 'Hr_Dashboard.Not_Enough_Information' | translate }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p">
      <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
        <div class="c-section__content">
          <div class="o-grid">
            <div class="o-grid__cell c-cell">
              <div class="c-card c-card--height-fit" style="min-height: 200px;">
                <div class="c-content u-no-pv u-ost-md u-osb-md">

                  <span class="c-text c-text--bold c-text--main u-no-m">
                    {{ 'Hr_Dashboard.Distribution' | translate }}
                  </span>
				  <select id="additionalInfoGroupSelect" name="additionalInfoGroupSelect" [(ngModel)]="vm.selectedAdditionalInfoGroup"
				  	(change)="selectUsageByAdditionalInfoGroup(vm.selectedAdditionalInfoGroup)">
					<option *ngFor="let groupId of vm.additionalInfoGroups" [value]="groupId">{{ groupId }}</option>
				  </select>
                  <ng-google-charts *ngIf="vm.conditionForPieChart"
                                    [data]="vm.pieChartOptions"
                                    [pngBase64Callback]="vm.getDistributionOfUsageGraph"></ng-google-charts>
                </div>
                <div *ngIf="!vm.conditionForPieChart" style="text-align: center; margin-top: 10px">
                  <i class="o-icon o-icon--personal" style="font-size:22px;"></i>
                  <div class="c-text c-text--center u-no-m">
                    {{ 'Hr_Dashboard.Not_Enough_Information' | translate }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <div class="o-grid o-grid--wrap" *ngIf="vm.hasProblemsToShow">
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p">
      <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
        <div class="o-grid o-grid--fit">
          <div class="o-grid__cell c-cell">
            <div class="c-text c-text--bold c-text--main u-no-m" style="font-size: 16px;">
              {{ 'Hr_Dashboard.Condition_Assessed_By_Therapist' | translate }}</div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <div class="o-grid o-grid--wrap" *ngIf="vm.hasProblemsToShow">
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p">
      <section class="c-section c-section--open c-section--static c-section--fit@md-and-up" panel>
        <div class="c-section__content">
          <div class="o-grid o-grid--fit">
            <div class="o-grid__cell c-cell">
              <div class="c-card c-card--height-fit">
                <div class="c-content u-no-pv u-ost-md u-osb-md">
                  <div class="o-grid o-grid--wrap">
                    <div class="o-grid__cell o-grid__cell--w-50 u-no-p">
                                           <span class="c-text c-text--bold c-text--main u-no-m">
                                                {{vm.firstPopularTag}}</span>
                      <div class="c-text">
                        <div class="c-text--bold c-text--main u-no-m"
                             style="font-size: 22px;">{{vm.firstTagPercent}}%
                        </div>
                        {{ 'Hr_Dashboard.Employee' | translate }}
                      </div>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-45@md-and-up o-grid__cell--w-25 o-grid__cell--right u-no-p">
                      <div role="progressbar" aria-valuenow="{{vm.firstTagPercent}}"
                           aria-valuemin="0" aria-valuemax="100" [style]="vm.getFirstProgressBarStyle()">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p">
      <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
        <div class="c-section__content">
          <div class="o-grid">
            <div class="o-grid__cell c-cell">
              <div class="c-card c-card--height-fit">
                <div class="c-content u-no-pv u-ost-md u-osb-md">
                  <div class="o-grid o-grid--wrap">
                    <div class="o-grid__cell o-grid__cell--w-50 u-no-p">
                                             <span class="c-text c-text--bold c-text--main u-no-m">
                                                {{vm.secondPopularTag}}</span>
                      <div class="c-text">
                        <div class="c-text--bold c-text--main u-no-m"
                             style="font-size: 22px;">{{vm.secondTagPercent}}%
                        </div>
                        {{ 'Hr_Dashboard.Employee' | translate }}
                      </div>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-45@md-and-up o-grid__cell--w-25 o-grid__cell--right u-no-p">
                      <div role="progressbar" aria-valuenow="{{vm.secondTagPercent}}"
                           aria-valuemin="0" aria-valuemax="100" [style]="vm.getSecondProgressBarStyle()">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p">
      <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
        <div class="c-section__content">
          <div class="o-grid o-grid--fit">
            <div class="o-grid__cell c-cell">
              <div class="c-card c-card--height-fit">
                <div class="c-content u-no-pv u-ost-md u-osb-md">
                  <div class="o-grid o-grid--wrap">
                    <div class="o-grid__cell o-grid__cell--w-50 u-no-p">
                                            <span class="c-text c-text--bold c-text--main u-no-m">
                                                {{vm.thirdPopularTag}}</span>
                      <div class="c-text">
                        <div class="c-text--bold c-text--main u-no-m"
                             style="font-size: 22px;">{{vm.thirdTagPercent}}%
                        </div>
                        {{ 'Hr_Dashboard.Employee' | translate }}
                      </div>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-45@md-and-up o-grid__cell--w-25 o-grid__cell--right u-no-p">
                      <div role="progressbar" aria-valuenow="{{vm.thirdTagPercent}}"
                           aria-valuemin="0" aria-valuemax="100" [style]="vm.getThirdProgressBarStyle()">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <div class="o-grid o-grid--wrap">
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p">
      <section class="c-section--open c-section--static c-section--fit@md-and-up u-no-pb" style="margin-left: 15px" panel>
        <div class="o-grid o-grid--fit">
          <div class="o-grid__cell c-cell">
            <div class="c-text c-text--bold c-text--main u-no-m" style="font-size: 20px;">
              2. {{ 'Hr_Dashboard.Return_On_Investment' | translate }}</div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <div class="o-grid o-grid--wrap">
    <div class="o-grid__cell o-grid__cell--w-100 u-no-p">
      <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
        <div class="c-section__content">
          <div class="o-grid o-grid--fit">
            <div class="o-grid__cell c-cell">
              <div class="c-card c-card--height-fit">
                <div class="o-grid o-grid--wrap">
                  <div class="o-grid__cell o-grid__cell--w-100" style="margin-top: 20px;">
                    <div class="c-text u-no-m" style="font-size: 16px">
                      {{ 'Hr_Dashboard.Fill_The_Number' | translate }}</div>
                  </div>
                  <div class="o-grid__cell o-grid__cell--w-55 o-grid__cell--left" style="margin-top: 30px; margin-bottom: 20px">
                    <div class="o-grid o-grid--wrap">
                      <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p@up-to-md u-no-pl">
                        <div class="c-form__group u-osb-lg">
                          <label class="c-form__label c-form__label--dark">{{ 'Hr_Dashboard.Average_Cost_For_Employer' | translate }}</label>
                          <input type="number" class="c-form__input c-form__input--sm" placeholder="&#8364;" [(ngModel)]="vm.averageCost" style="color: grey">
                        </div>
                        <div class="c-form__group u-osb-lg">
                          <label class="c-form__label c-form__label--dark">{{ 'Hr_Dashboard.Monthly_Payment_For_Our_Service' | translate }}</label>
                          <input type="number" class="c-form__input c-form__input--sm" placeholder="&#8364;" [(ngModel)]="vm.monthlyPayment" style="color: grey">
                        </div>
                      </div>
                      <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p@up-to-md u-no-pr">
                        <div class="c-form__group u-osb-lg">
                          <label class="c-form__label c-form__label--dark">{{ 'Hr_Dashboard.Number_Of_Total_Employees' | translate }}</label>
                          <input type="number" class="c-form__input c-form__input--sm" [(ngModel)]="vm.employeesNumber" style="color: grey">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="o-grid__cell o-grid__cell--w-45 o-grid__cell--right" style="display: flex; justify-content: center; align-items: center;">
                    <div class="o-grid o-grid--wrap">
                      <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p@up-to-md u-no-pl" style="display: flex; gap: 15px; flex-wrap: wrap">
                        <div class="c-text c-text--md c-text--bold u-no-m">
                          {{ 'Hr_Dashboard.Approximate_Savings' | translate }}
                        </div>
                        <div class="c-text--bold c-text--main u-no-m"
                             style="font-size: 24px; width: 100%">{{vm.approximateSavings ? vm.approximateSavings : 'n/a '}}&#8364;
                        </div>
                        <span class="c-text" style="font-size: 13px; color: #175624;" id="showCalculationInfo">{{ 'Hr_Dashboard.See_How_Is_Calculated' | translate }}
                          <roi-calculator-info-popover placement="right"
                                                       placementMobile="top"
                                                       [wrapperMobile]="vm.popoverMobileWrapper"
                                                       (click)="$event.preventDefault()"
                                                       style="vertical-align:middle" class="u-osl-xs">
                          </roi-calculator-info-popover>
                        </span>
                      </div>
                      <div class="o-grid__cell c-text--md o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p@up-to-md u-no-pl" style="display: flex; flex-wrap: wrap">
                        <div class="c-text c-text--bold u-no-m">
                          {{ 'Hr_Dashboard.Approximate_Return_On_Investment' | translate }}
                        </div>
                        <div class="c-text--bold c-text--main u-no-m"
                             style="font-size: 24px;">{{vm.approximateReturnOnInvestment ? vm.approximateReturnOnInvestment : 'n/a '}} x
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <div class="o-grid o-grid--wrap" *ngIf="vm.generatedPreview?.aiRecommendationsEnabled">
    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p">
      <section class="c-section--open c-section--static c-section--fit@md-and-up u-no-pb" style="margin-left: 15px" panel>
        <div class="o-grid o-grid--fit">
          <div class="o-grid__cell c-cell">
            <div class="c-text c-text--bold c-text--main u-no-m" style="font-size: 20px;">
              3. {{ 'Hr_Dashboard.AI_Recommendations' | translate }}</div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <div class="o-grid o-grid--wrap" *ngIf="vm.generatedPreview?.aiRecommendationsEnabled">
    <div class="o-grid__cell o-grid__cell--w-100 u-no-p">
      <section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
        <div class="c-section__content">
          <div class="o-grid o-grid--fit">
            <div class="o-grid__cell c-cell">
              <div class="c-card c-card--height-fit" style="min-height:120px;">
                <div *ngIf="!aiRecommendations && !vm.aiRecommendationsLoading" class="o-grid o-grid--wrap">
                  <div class="o-grid__cell o-grid__cell--w-100" style="margin-top: 20px;">
                    <div class="c-text u-no-m" style="font-size: 16px">
                      {{ 'Hr_Dashboard.AI_Recommendations_Intro' | translate }}</div>
                  </div>
                </div>
                <div *ngIf="!aiRecommendations && !aiRecommendationsLoading" class="o-grid__cell o-grid__cell--slim o-grid__cell--w-fixed o-grid__cell--right u-no-p" style="margin-right:20px;margin-top:20px;margin-bottom:20px;">
                  <a id="generateAiRecommendations" href="javascript:void(0)" class="c-button c-button--s1 c-button--fixed"
                     (click)="vm.getReportPreviewAiRecommendations()">{{ 'Common.Generate' | translate }}</a>
                </div>
                <div class="o-grid o-grid--wrap" *ngIf="aiRecommendations && !aiRecommendationsLoading">
                  <div class="o-grid__cell o-grid__cell--w-100" style="margin-top: 20px;margin-bottom:20px;">
                    <div class="c-text u-no-m" style="font-size: 16px;white-space: pre-wrap;" [innerHTML]="aiRecommendations | markdownBold"></div>
                  </div>
                </div>
                <loader-overlay *ngIf="aiRecommendationsLoading"></loader-overlay>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
